BookingApp.controller('FlightController',function($scope,FlightServices,$routeParams,$filter,$location){
    $scope.InBond = $scope.$resolve.InBond.flight[$routeParams.Index];
    $scope.IsInterNational = $scope.$resolve.InBond.International;
    console.log($scope.InBond.fareQuote.Response.Results.Segments[0]);
})